export default function Dashboard() {
  const stats = [
    { title: "إجمالي الطلاب", value: "124", icon: "👨‍🎓", color: "#4CAF50", change: "+12%" },
    { title: "الكورسات النشطة", value: "8", icon: "📚", color: "#2196F3", change: "+2" },
    { title: "المشتركين الجدد", value: "42", icon: "🆕", color: "#FF9800", change: "+8%" },
    { title: "متوسط التقييم", value: "4.8", icon: "⭐", color: "#9C27B0", change: "+0.2" },
  ];

  const recentActivities = [
    { id: 1, student: "أحمد محمد", action: "اشترك في كورس الرياضيات", time: "منذ 5 دقائق", icon: "🎯" },
    { id: 2, student: "سارة خالد", action: "أكمل الدرس الثالث", time: "منذ ساعة", icon: "✅" },
    { id: 3, student: "محمد علي", action: "أضاف تقييم 5 نجوم", time: "منذ 3 ساعات", icon: "⭐" },
    { id: 4, student: "فاطمة حسن", action: "رفع واجب الدرس", time: "منذ 5 ساعات", icon: "📤" },
    { id: 5, student: "خالد سعيد", action: "بدأ كورس البرمجة", time: "منذ يوم", icon: "🚀" },
  ];

  const quickActions = [
    { title: "إنشاء كورس جديد", icon: "🆕", color: "#667eea", link: "/trainer/courses/create" },
    { title: "إضافة طالب", icon: "👨‍🎓", color: "#4CAF50", link: "/trainer/students/create" },
    { title: "إدارة روابط التواصل", icon: "📱", color: "#FF9800", link: "/trainer/contacts" },
    { title: "تعديل الملف الشخصي", icon: "👤", color: "#9C27B0", link: "/trainer/profile" },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.welcomeSection}>
        <div style={styles.welcomeContent}>
          <h1 style={styles.welcomeTitle}>مرحبًا بك، المدرّب محمد! 👋</h1>
          <p style={styles.welcomeText}>هذا ملخص لأدائك ونشاطاتك لهذا الأسبوع</p>
        </div>
        <div style={styles.dateSection}>
          <span style={styles.dateText}>{new Date().toLocaleDateString('ar-SA', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
          <span style={styles.timeText}>{new Date().toLocaleTimeString('ar-SA', { hour: '2-digit', minute: '2-digit' })}</span>
        </div>
      </div>

      <div style={styles.statsGrid}>
        {stats.map((stat, index) => (
          <div key={index} style={{...styles.statCard, borderLeft: `4px solid ${stat.color}`}}>
            <div style={styles.statHeader}>
              <div style={{...styles.statIcon, background: `${stat.color}20`}}>
                <span style={{...styles.statIconText, color: stat.color}}>{stat.icon}</span>
              </div>
              <span style={styles.statChange}>{stat.change}</span>
            </div>
            <h3 style={styles.statValue}>{stat.value}</h3>
            <p style={styles.statTitle}>{stat.title}</p>
          </div>
        ))}
      </div>

      <div style={styles.contentGrid}>
        <div style={styles.mainContent}>
          <div style={styles.sectionCard}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>📈 الإحصائيات الأسبوعية</h2>
              <select style={styles.select}>
                <option>الأسبوع الحالي</option>
                <option>الأسبوع الماضي</option>
                <option>الشهر الحالي</option>
              </select>
            </div>
            <div style={styles.chartPlaceholder}>
              <div style={styles.chartBar}><div style={{...styles.chartFill, height: '80%', background: '#4CAF50'}}></div><span>الطلاب</span></div>
              <div style={styles.chartBar}><div style={{...styles.chartFill, height: '60%', background: '#2196F3'}}></div><span>الكورسات</span></div>
              <div style={styles.chartBar}><div style={{...styles.chartFill, height: '90%', background: '#FF9800'}}></div><span>المشتركين</span></div>
              <div style={styles.chartBar}><div style={{...styles.chartFill, height: '70%', background: '#9C27B0'}}></div><span>التقييمات</span></div>
            </div>
          </div>

          <div style={styles.sectionCard}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>📝 النشاطات الحديثة</h2>
              <button style={styles.viewAllButton}>عرض الكل</button>
            </div>
            <div style={styles.activitiesList}>
              {recentActivities.map(activity => (
                <div key={activity.id} style={styles.activityItem}>
                  <div style={styles.activityIcon}>{activity.icon}</div>
                  <div style={styles.activityContent}>
                    <h4 style={styles.activityStudent}>{activity.student}</h4>
                    <p style={styles.activityAction}>{activity.action}</p>
                  </div>
                  <span style={styles.activityTime}>{activity.time}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={styles.sidebar}>
          <div style={styles.sectionCard}>
            <h2 style={styles.sectionTitle}>⚡ إجراءات سريعة</h2>
            <div style={styles.quickActionsGrid}>
              {quickActions.map((action, index) => (
                <a key={index} href={action.link} style={styles.quickActionLink}>
                  <div style={{...styles.quickAction, background: `${action.color}20`}}>
                    <span style={{...styles.quickActionIcon, color: action.color}}>{action.icon}</span>
                    <span style={styles.quickActionTitle}>{action.title}</span>
                  </div>
                </a>
              ))}
            </div>
          </div>

          <div style={styles.sectionCard}>
            <h2 style={styles.sectionTitle}>🎯 أهدافك لهذا الشهر</h2>
            <div style={styles.goalsList}>
              <div style={styles.goalItem}>
                <span style={styles.goalText}>جذب 50 طالب جديد</span>
                <div style={styles.progressBar}>
                  <div style={{...styles.progressFill, width: '75%', background: '#4CAF50'}}></div>
                </div>
                <span style={styles.goalPercent}>75%</span>
              </div>
              <div style={styles.goalItem}>
                <span style={styles.goalText}>إنشاء 3 كورسات جديدة</span>
                <div style={styles.progressBar}>
                  <div style={{...styles.progressFill, width: '33%', background: '#2196F3'}}></div>
                </div>
                <span style={styles.goalPercent}>33%</span>
              </div>
              <div style={styles.goalItem}>
                <span style={styles.goalText}>رفع التقييم إلى 4.9</span>
                <div style={styles.progressBar}>
                  <div style={{...styles.progressFill, width: '90%', background: '#FF9800'}}></div>
                </div>
                <span style={styles.goalPercent}>90%</span>
              </div>
            </div>
          </div>

          <div style={styles.sectionCard}>
            <h2 style={styles.sectionTitle}>📊 أفضل الكورسات</h2>
            <div style={styles.topCourses}>
              <div style={styles.courseItem}>
                <span style={styles.courseRank}>🥇</span>
                <div style={styles.courseInfo}>
                  <h4 style={styles.courseName}>الرياضيات المتقدمة</h4>
                  <span style={styles.courseStudents}>48 طالب</span>
                </div>
                <span style={styles.courseRating}>⭐ 4.9</span>
              </div>
              <div style={styles.courseItem}>
                <span style={styles.courseRank}>🥈</span>
                <div style={styles.courseInfo}>
                  <h4 style={styles.courseName}>برمجة Python</h4>
                  <span style={styles.courseStudents}>36 طالب</span>
                </div>
                <span style={styles.courseRating}>⭐ 4.8</span>
              </div>
              <div style={styles.courseItem}>
                <span style={styles.courseRank}>🥉</span>
                <div style={styles.courseInfo}>
                  <h4 style={styles.courseName}>اللغة الإنجليزية</h4>
                  <span style={styles.courseStudents}>29 طالب</span>
                </div>
                <span style={styles.courseRating}>⭐ 4.7</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    direction: 'rtl',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  welcomeSection: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    padding: '30px',
    borderRadius: '15px',
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)',
  },
  welcomeContent: {
    flex: 1,
  },
  welcomeTitle: {
    margin: '0 0 10px 0',
    fontSize: '1.8rem',
    fontWeight: '700',
  },
  welcomeText: {
    margin: 0,
    fontSize: '1rem',
    opacity: '0.9',
  },
  dateSection: {
    textAlign: 'left',
    background: 'rgba(255, 255, 255, 0.1)',
    padding: '15px 20px',
    borderRadius: '10px',
    backdropFilter: 'blur(10px)',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  dateText: {
    fontSize: '0.9rem',
    fontWeight: '500',
  },
  timeText: {
    fontSize: '1.2rem',
    fontWeight: '700',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '20px',
    marginBottom: '30px',
  },
  statCard: {
    background: 'white',
    padding: '25px',
    borderRadius: '12px',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  statHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
  },
  statIcon: {
    width: '50px',
    height: '50px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  statIconText: {
    fontSize: '1.8rem',
  },
  statChange: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#4CAF50',
  },
  statValue: {
    margin: '0 0 5px 0',
    fontSize: '2.2rem',
    fontWeight: '700',
    color: '#333',
  },
  statTitle: {
    margin: 0,
    fontSize: '0.95rem',
    color: '#666',
  },
  contentGrid: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: '30px',
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  sectionCard: {
    background: 'white',
    padding: '25px',
    borderRadius: '12px',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  sectionTitle: {
    margin: 0,
    fontSize: '1.3rem',
    color: '#333',
    fontWeight: '600',
  },
  select: {
    padding: '8px 15px',
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    fontSize: '0.9rem',
    backgroundColor: 'white',
  },
  viewAllButton: {
    padding: '8px 20px',
    background: '#f5f5f5',
    color: '#666',
    border: 'none',
    borderRadius: '6px',
    fontSize: '0.9rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  chartPlaceholder: {
    height: '200px',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-around',
    gap: '20px',
    padding: '20px 0',
  },
  chartBar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    flex: 1,
  },
  chartFill: {
    width: '40px',
    borderRadius: '8px 8px 0 0',
    transition: 'height 0.3s ease',
  },
  activitiesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  activityItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    padding: '15px',
    borderRadius: '8px',
    border: '1px solid #f0f0f0',
    transition: 'all 0.3s ease',
  },
  activityIcon: {
    fontSize: '1.5rem',
    width: '45px',
    height: '45px',
    background: '#f8f9ff',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  activityContent: {
    flex: 1,
  },
  activityStudent: {
    margin: '0 0 5px 0',
    fontSize: '1rem',
    color: '#333',
    fontWeight: '600',
  },
  activityAction: {
    margin: 0,
    fontSize: '0.9rem',
    color: '#666',
  },
  activityTime: {
    fontSize: '0.8rem',
    color: '#999',
  },
  quickActionsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '15px',
  },
  quickActionLink: {
    textDecoration: 'none',
  },
  quickAction: {
    padding: '20px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    transition: 'all 0.3s ease',
  },
  quickActionIcon: {
    fontSize: '1.8rem',
  },
  quickActionTitle: {
    fontSize: '1rem',
    color: '#333',
    fontWeight: '500',
  },
  goalsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  goalItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  goalText: {
    fontSize: '0.95rem',
    color: '#333',
    fontWeight: '500',
  },
  progressBar: {
    height: '8px',
    background: '#f0f0f0',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: '4px',
    transition: 'width 0.3s ease',
  },
  goalPercent: {
    fontSize: '0.9rem',
    color: '#666',
    textAlign: 'left',
  },
  topCourses: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  courseItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    padding: '15px',
    borderRadius: '8px',
    border: '1px solid #f0f0f0',
    transition: 'all 0.3s ease',
  },
  courseRank: {
    fontSize: '1.5rem',
    width: '40px',
    textAlign: 'center',
  },
  courseInfo: {
    flex: 1,
  },
  courseName: {
    margin: '0 0 5px 0',
    fontSize: '1rem',
    color: '#333',
    fontWeight: '600',
  },
  courseStudents: {
    fontSize: '0.8rem',
    color: '#666',
  },
  courseRating: {
    fontSize: '0.9rem',
    color: '#FF9800',
    fontWeight: '600',
  },
};

// إضافة تأثيرات Hover
if (typeof window !== 'undefined') {
  setTimeout(() => {
    const style = document.createElement('style');
    style.textContent = `
      .stat-card-hover:hover {
        transform: translateY(-5px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15) !important;
      }
      
      .activity-item-hover:hover {
        background: #f8f9ff !important;
        border-color: #667eea !important;
        transform: translateX(-5px);
      }
      
      .quick-action-hover:hover {
        transform: translateX(-5px) !important;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
      }
      
      .course-item-hover:hover {
        background: #f8f9ff !important;
        border-color: #667eea !important;
      }
      
      .view-all-btn-hover:hover {
        background: #667eea !important;
        color: white !important;
      }
      
      .select-focus:focus {
        outline: none;
        border-color: #667eea !important;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
      }
      
      @media (max-width: 1024px) {
        .content-grid-responsive {
          grid-template-columns: 1fr !important;
        }
      }
      
      @media (max-width: 768px) {
        .welcome-section-responsive {
          flex-direction: column !important;
          text-align: center !important;
          gap: 20px !important;
        }
        
        .date-section-responsive {
          width: 100% !important;
          text-align: center !important;
        }
        
        .stats-grid-responsive {
          grid-template-columns: repeat(2, 1fr) !important;
        }
      }
      
      @media (max-width: 480px) {
        .stats-grid-responsive {
          grid-template-columns: 1fr !important;
        }
        
        .chart-placeholder-responsive {
          flex-direction: column !important;
          height: auto !important;
        }
        
        .chart-bar-responsive {
          flex-direction: row !important;
          width: 100% !important;
        }
        
        .chart-fill-responsive {
          width: 100% !important;
          height: 40px !important;
          border-radius: 8px !important;
        }
      }
    `;
    document.head.appendChild(style);
    
    // إضافة classes للعناصر
    setTimeout(() => {
      document.querySelectorAll('[style*="statCard"]').forEach(el => {
        el.className = (el.className || '') + ' stat-card-hover';
      });
      document.querySelectorAll('[style*="activityItem"]').forEach(el => {
        el.className = (el.className || '') + ' activity-item-hover';
      });
      document.querySelectorAll('[style*="quickAction"]').forEach(el => {
        el.className = (el.className || '') + ' quick-action-hover';
      });
      document.querySelectorAll('[style*="courseItem"]').forEach(el => {
        el.className = (el.className || '') + ' course-item-hover';
      });
      document.querySelectorAll('[style*="viewAllButton"]').forEach(el => {
        el.className = (el.className || '') + ' view-all-btn-hover';
      });
      document.querySelectorAll('select').forEach(el => {
        el.className = (el.className || '') + ' select-focus';
      });
      
      // Responsive classes
      if (window.innerWidth <= 1024) {
        const contentGrid = document.querySelector('[style*="contentGrid"]');
        if (contentGrid) contentGrid.className = (contentGrid.className || '') + ' content-grid-responsive';
      }
      if (window.innerWidth <= 768) {
        const welcomeSection = document.querySelector('[style*="welcomeSection"]');
        const dateSection = document.querySelector('[style*="dateSection"]');
        const statsGrid = document.querySelector('[style*="statsGrid"]');
        if (welcomeSection) welcomeSection.className = (welcomeSection.className || '') + ' welcome-section-responsive';
        if (dateSection) dateSection.className = (dateSection.className || '') + ' date-section-responsive';
        if (statsGrid) statsGrid.className = (statsGrid.className || '') + ' stats-grid-responsive';
      }
      if (window.innerWidth <= 480) {
        const chart = document.querySelector('[style*="chartPlaceholder"]');
        const chartBars = document.querySelectorAll('[style*="chartBar"]');
        const chartFills = document.querySelectorAll('[style*="chartFill"]');
        if (chart) chart.className = (chart.className || '') + ' chart-placeholder-responsive';
        chartBars.forEach(el => {
          el.className = (el.className || '') + ' chart-bar-responsive';
        });
        chartFills.forEach(el => {
          el.className = (el.className || '') + ' chart-fill-responsive';
        });
      }
    }, 200);
  }, 100);
}